import { z } from "zod";

export const statusMonitoramentoGruposSchema = z.object({
  wahaConfigurado: z.boolean(),
  wahaBaseUrl: z.string().nullable(),
  clickupTokenOk: z.boolean(),
  clickupListIdGrupos: z.string().nullable(),
  instanciasSelecionadas: z.array(z.string()),
  prontoParaUsar: z.boolean(),
});
export type StatusMonitoramentoGruposDto = z.infer<
  typeof statusMonitoramentoGruposSchema
>;

export const salvarWahaSchema = z.object({
  wahaBaseUrl: z.string().url(),
  wahaToken: z.string().min(1),
});
export type SalvarWahaDto = z.infer<typeof salvarWahaSchema>;

export const salvarListIdGruposSchema = z.object({
  clickupListIdGrupos: z.string().min(1),
});
export type SalvarListIdGruposDto = z.infer<typeof salvarListIdGruposSchema>;

export const salvarInstanciasSchema = z.object({
  instancias: z.array(z.string().min(1)).min(1),
});
export type SalvarInstanciasDto = z.infer<typeof salvarInstanciasSchema>;

export const instanciaWahaSchema = z.object({
  nome: z.string(),
  status: z.string(),
  selecionada: z.boolean(),
});
export type InstanciaWahaDto = z.infer<typeof instanciaWahaSchema>;

export const grupoQualificadoSchema = z.object({
  chatId: z.string(),
  nome: z.string(),
  sessao: z.string(),
  nomeCliente: z.string(),
});
export type GrupoQualificadoDto = z.infer<typeof grupoQualificadoSchema>;

export const testarGrupoSchema = z.object({
  sessao: z.string().min(1),
  chatId: z.string().min(1),
  nomeGrupo: z.string().min(1),
  dataReferencia: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
});
export type TestarGrupoDto = z.infer<typeof testarGrupoSchema>;

export const resultadoTesteGrupoSchema = z.object({
  nomeCliente: z.string(),
  mensagens: z.number().int().nonnegative(),
  resumo: z.string(),
  clickupTaskId: z.string(),
  clickupTaskUrl: z.string().nullable(),
  taskNova: z.boolean(),
  commentId: z.string(),
  dataReferencia: z.string(),
  omitido: z.boolean().optional(),
});
export type ResultadoTesteGrupoDto = z.infer<typeof resultadoTesteGrupoSchema>;
